import { render, staticRenderFns } from "./EventoForm.vue?vue&type=template&id=6615a208&"
import script from "./EventoForm.vue?vue&type=script&lang=js&"
export * from "./EventoForm.vue?vue&type=script&lang=js&"
import style0 from "./EventoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports